module.exports = __webpack_public_path__ + "4.dd77cc9a389082233e62.png";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/patterns/4.png
// module id = 602
// module chunks = 2